import { useLayoutEffect, useState } from 'react'
import BaseService from '../../utils/api'

// Observe requests only during an arrival from an activity. Requests and
// responses pass through unchanged; this does not change section loading.
export default function useCaseActivityPageLoading(enabled) {
    const [pending, setPending] = useState(0)
    useLayoutEffect(() => {
        if (!enabled) {
            setPending(0)
            return undefined
        }
        const active = new Set()
        let mounted = true
        const update = () => { if (mounted) setPending(active.size) }
        const finish = (config) => {
            active.delete(config?.__activityArrivalRequestId)
            update()
        }
        const request = BaseService.interceptors.request.use((config) => {
            // The same ID survives the client's existing auth retry.
            if (!config.__activityArrivalRequestId) config.__activityArrivalRequestId = Symbol('activity-arrival')
            active.add(config.__activityArrivalRequestId)
            update()
            return config
        })
        const response = BaseService.interceptors.response.use(
            (result) => { finish(result.config); return result },
            (error) => { finish(error.config); return Promise.reject(error) }
        )
        return () => {
            mounted = false
            BaseService.interceptors.request.eject(request)
            BaseService.interceptors.response.eject(response)
        }
    }, [enabled])
    return pending === 0
}
